import Backdrop from '@mui/material/Backdrop';
import Fade from '@mui/material/Fade';
import Modal from '@mui/material/Modal';
import { makeStyles } from '@mui/styles';
import React from 'react';

const useStyles = makeStyles(_ => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: '#FFF',
    border: '2px solid #000',
    padding: 2,
    borderRadius: 4,
  },
}));

export default function TransitionModal({
  isOpen,
  title,
  description,
  modalContent: ModalContent,
  onClose,
}: {
  isOpen: boolean;
  title?: string;
  description?: string;
  modalContent: () => React.ReactNode;
  onClose: () => void;
}) {
  const classes = useStyles();
  return (
    <div className="modal">
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={isOpen}
        onClose={onClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}>
        <Fade in={isOpen}>
          <div className={`modal-content ${classes.paper}`}>
            {title ? <h2 className="">{title}</h2> : null}
            {description ? <p id="transition-modal-description">{description}</p> : null}
            {ModalContent()}
          </div>
        </Fade>
      </Modal>
    </div>
  );
}
